module.exports = "/_next/static/images/BuildHighPerformance-2@2x-ad47490a3936450924232faf5a149485.webp";